module.exports = __webpack_public_path__ + "assets/img/preview_01.6db64b59.png";